import {Stack} from "@mui/material"
import React from "react"
import Content from "../../components/Content"

const ContainerCentered= ({container}) => {
    return (
        <Stack height="100%" justifyContent="center">
            {container.children.map(child => (
                <Content key={child.id} child={child} />
            ))}
        </Stack>
    )
}

export default ContainerCentered
